export const WHITE_LABEL_BLOCKED_URLS = ['/accounts/list'];
export const WHITE_LABEL_HEADER_NAME = 'whitelabel';
